export const visit = (vm, at) => {
at({ "cs": { "conversationsVisitorUIPageTitleNotifications": { "newMessage": "Nov\xE1 zpr\xE1va" } } });
};